import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import NotificationsActive from "@mui/icons-material/NotificationsActive";

import Snackbar from "components/snackbar/snackbar";

import exportAttributeValues from "api/attributeValues/export";

import canExportAttributes from "./canExportAttributes";

AttributeExportButton.propTypes = {
    type: PropTypes.string.isRequired,
    optionId: PropTypes.string,
};

/**
 * Self-contained export button for the attribute management pages: requests
 * the asynchronous export (emailed to the user) and notifies the outcome.
 * Renders nothing without the dedicated export authorization.
 */
export default function AttributeExportButton({type, optionId}) {
    const intl = useIntl();
    const [isSuccessNotificationDisplayed, setSuccessNotificationDisplayed] = useState(false);
    const [isErrorNotificationDisplayed, setErrorNotificationDisplayed] = useState(false);
    const [isExporting, setExporting] = useState(false);

    if (!canExportAttributes()) {
        return null;
    }

    function handleClick() {
        // disabled while the request runs: each click sends one email
        setExporting(true);

        exportAttributeValues(type, optionId)
            .then(() => setSuccessNotificationDisplayed(true))
            .catch(() => setErrorNotificationDisplayed(true))
            .finally(() => setExporting(false));
    }

    return (
        <>
            <IconButton
                onClick={() => handleClick()}
                disabled={isExporting}
                aria-label={intl.formatMessage({id: 'attributeExport.button.label'})}
            >
                <FileDownloadOutlinedIcon />
            </IconButton>
            <Snackbar
                open={isSuccessNotificationDisplayed}
                close
                closeNotification={() => setSuccessNotificationDisplayed(false)}
                place={"bl"}
                color={"success"}
                icon={() => <NotificationsActive />}
                message={<FormattedMessage id={"list.export.success"} />}
            />
            <Snackbar
                open={isErrorNotificationDisplayed}
                close
                closeNotification={() => setErrorNotificationDisplayed(false)}
                place={"bl"}
                color={"danger"}
                icon={() => <NotificationsActive />}
                message={<FormattedMessage id={"list.error"} />}
            />
        </>
    );
}
